
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersNight as ObiLightningHeavyRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-night.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-night',
   elementClass: ObiLightningHeavyRainShowersNightElement,
   events: {
     
   }
  });
 
 